import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import Header from "./components/Header";
import Home from "./pages/Home";
import CalculateCost from "./pages/CalculateCost";
import ContactModal from "./components/ContactModal";
import WhatsAppFloat from "./components/WhatsAppFloat";
import AOS from "aos";
import "aos/dist/aos.css";
import Projects from "./pages/Projects";
import FaqPage from "./pages/FaqPage";
import "./style.css";
import BookMeetingModal from "./components/BookMeetingModal";
import CalculateEstimate from "./pages/CalculateEstimate";
import Architecture from "./pages/Architecture";
 import Liaisoning from "./pages/Liaisoning";
import Interior from "./pages/Interior";
import Construction from "./pages/Construction"; 
import PMC from "./pages/PMC";
import ScrollToTop from "./ScrollToTop";
import ProjectDetails from "./pages/ProjectDetails";
import LegalPage from "./pages/LegalPage";


function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMeetingOpen, setIsMeetingOpen] = useState(false);

  const [scrollDir, setScrollDir] = useState("up");
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);

  //  AOS Init
  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: false,
      offset: 100,
    });
  }, []);

  //  Resize Detect (Mobile/Desktop Switch)
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 991);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  //  Scroll Direction Detect (Only for Mobile Logic)
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // Prevent tiny scroll flicker
      if (Math.abs(currentScrollY - lastScrollY) < 10) return;

      if (currentScrollY > lastScrollY) {
        setScrollDir("down");
      } else {
        setScrollDir("up");
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  //  Modal Controls
  const openContactModal = () => setIsModalOpen(true);
  const closeContactModal = () => setIsModalOpen(false);

  const openMeetingModal = () => setIsMeetingOpen(true);
  const closeMeetingModal = () => setIsMeetingOpen(false);

  return (
    <BrowserRouter>
      {/* <div className="site-wrapper"> */}
        
        {/* Header */}
        <Header
          openContactModal={openContactModal}
          openMeetingModal={openMeetingModal}
        />

        {/* Global Modals */}
        <ContactModal isOpen={isModalOpen} closeModal={closeContactModal} />
        <BookMeetingModal isOpen={isMeetingOpen} closeModal={closeMeetingModal} />

        {/* Floating Button */}
        <WhatsAppFloat
          visible={isMobile ? scrollDir === "up" : true}
        />

  <ScrollToTop />
        <Routes>

        <Route path="/architecture" element={<Architecture openContactModal={openContactModal} showCTA={isMobile ? scrollDir === "down" : false} />} />   
        <Route 
  path="/interior" 
  element={
    <Interior 
      openContactModal={openContactModal} 
      showCTA={isMobile ? scrollDir === "down" : false} 
    />
  } 
/>
        <Route path="/construction" element={<Construction openContactModal={openContactModal} showCTA={isMobile ? scrollDir === "down" : false} />} /> 
        
        <Route path="/pmc" element={<PMC openContactModal={openContactModal} showCTA={isMobile ? scrollDir === "down" : false} />} /> 

        <Route 
  path="/liaisoning" 
  element={
    <Liaisoning 
      openContactModal={openContactModal}
      showCTA={isMobile ? scrollDir === "down" : false}
    />
  } 
/>

          <Route
            path="/"
            element={
              <Home
                openContactModal={openContactModal}
                openMeetingModal={openMeetingModal}
                showCTA={isMobile ? scrollDir === "down" : false}
              />
            }
          />

          <Route
            path="/calculate"
            element={<CalculateCost openContactModal={openContactModal} />}
          />

          <Route
  path="/estimate"
  element={<CalculateEstimate openContactModal={openContactModal} />}
/>

          {/* <Route path="/projects" element={<Projects />} /> */}

         <Route path="/projects" element={ <Projects openContactModal={openContactModal} openMeetingModal={openMeetingModal} showCTA={isMobile ? scrollDir === "down" : false} /> } />

          <Route path="/projects/:slug" element={<ProjectDetails openContactModal={openContactModal} showCTA={isMobile ? scrollDir === "down" : false} />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/privacy" element={<LegalPage openContactModal={openContactModal} showCTA={isMobile ? scrollDir === "down" : false} />} />
          <Route path="/help" element={<LegalPage openContactModal={openContactModal} showCTA={isMobile ? scrollDir === "down" : false} />} />
          <Route path="/cookies-policy" element={<LegalPage openContactModal={openContactModal} showCTA={isMobile ? scrollDir === "down" : false} />} />
          <Route path="/credits" element={<LegalPage openContactModal={openContactModal} showCTA={isMobile ? scrollDir === "down" : false} />} />
          <Route path="/:slug" element={<ProjectDetails openContactModal={openContactModal} showCTA={isMobile ? scrollDir === "down" : false} />} />
        </Routes>
      {/* </div> */}
    </BrowserRouter>
  );
}

export default App;
